import React from 'react';
import { Edit, DateTimeInput, FormTab, TabbedForm } from 'react-admin';
import {Grid} from "@material-ui/core";

const PhasesEdit = ({ staticContext, ...props }) => {
    return (
        <Edit
            resource="phases"
            basePath="/phases"
            redirect={false}
            title="Wettbewerb"
            {...props}>
            <TabbedForm>
                <FormTab label="Phasen">
                    <Grid container spacing={2}>
                        <Grid item md={12}>
                            <DateTimeInput source="campaignLaunch" label="Kampagnen-Launch" step="1"/>
                        </Grid>
                        <Grid item md={12}>
                            <DateTimeInput source="voteStart" label="Abstimmungsstart" step="1"/>
                        </Grid>
                        <Grid item md={12}>
                            <DateTimeInput source="voteStartFinale" label="Finalstart" step="1"/>
                        </Grid>
                        <Grid item md={12}>
                            <DateTimeInput source="voteEnd" label="Abstimmungsende" step="1"/>
                        </Grid>
                    </Grid>
                </FormTab>
            </TabbedForm>
        </Edit>
    );
};

export default PhasesEdit;
